import { useStaticQuery, graphql } from "gatsby"
import { Link } from "@StarberryUtils";
import React, { useEffect, useState } from "react";
import $ from 'jquery'
import { navigate } from "@reach/router"
import axios from "axios";
import Select from 'react-select';
import { Button, Container, Form, Tabs, Tab } from 'react-bootstrap';
import _ from "lodash";
import SearchInputBox from "../../predictive-search/SearchBox";
// markup
import "./HeroSearch.scss";

const HeroSearch = (props) => {

  const areasQuery = useStaticQuery(graphql`
    query areasQuery {
      glstrapi {
        areas {
          alias
          area
          areaID
          createdAt
          id
          location
          published_at
          type
        }
      }
    }
  `)

  const [key, setKey] = React.useState(props?.type === "offplan" ? 'off-plan' : props?.type === "Rent" ? 'rent' : 'buy');
  const [type, setType] = useState(1);
  const [firstRender, setFirstRender] = useState(false);
  const [propCount, setPropCount] = useState(0);
  const [beds, setBeds] = useState("");
  const [minPrice, setMinPrice] = useState("0");
  const [maxPrice, setMaxPrice] = useState("0");
  const [propertType, setPropertyType] = useState("");
  const [areas, setAreas] = useState([]);
  const [renderComponent, setRenderComponent] = useState(false);




  const getitems = async url => {
    try {
      const { data } = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${process.env.GATSBY_STRAPI_FORM_TOKEN}`,
        }
      })
      setPropCount(data)
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    $('.react-autosuggest__input').on('click', function () {
      if (props.handleChange) {
        props.handleChange("stop");
      }
    });

    // Property search results 
    $(document).mouseup(function (e) {
      var container = $(".price-filter-dropdown");

      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        $(".price-filter-dropdown").removeClass("active");
      }
    });

    let url = process.env.GATSBY_STRAPI_SRC + "/properties/count?publish=true"; // TODO: base URL supposed to be from .env   
    if (props.type === "Buy_and_Rent") {
      getitems(url)
    }
    if (!_.isEmpty(areasQuery.glstrapi?.areas)) {
      setAreas(areasQuery.glstrapi?.areas)
    }

    window.addEventListener("mousemove", () => {

      if (renderComponent === false) {
        setRenderComponent(true)
      }
    })
    window.addEventListener("keypress", () => {
      if (renderComponent === false) {
        setRenderComponent(true)
      }
    })
    window.addEventListener("touchmove", () => {
      if (renderComponent === false) {
        setRenderComponent(true)
      }
    })


  }, [])

  const advanceSearch = (e) => {
    let url = "/";


    var searcValue = $(".hero-overlay .non-commercial .searchVal").val().split(', ').join('-').replace(/ /g, "-").replace(/'/g, "").toLowerCase();
    if (key === "commercial") {
      searcValue = $(".hero-overlay .commercial .searchVal").val().split(', ').join('-').replace(/ /g, "-").replace(/'/g, "").toLowerCase();
    }
    if (key === "off-plan") {
      searcValue = $(".hero-overlay .commercial .searchVal").val().split(', ').join('-').replace(/ /g, "-").replace(/'/g, "").toLowerCase();
    }

    if (searcValue !== "") {
      url = "in-" + searcValue + "/"
    } else {
      if (key === "off-plan") {
        url = ""
      } else {
        url = "in-dubai/"
      }
    }
    if (propertType !== "") {
      url = `${url}type-${propertType}/`
    }
    if (beds !== "") {
      url = `${url}${beds}-and-more-bedrooms/`
    }


    if (minPrice != "0" && maxPrice !== "0") {
      url = `${url}between-aed${minPrice}-and-aed${maxPrice}/`
    } else {
      if (minPrice != "0") {
        url = `${url}above-aed${minPrice}/`
      }
      if (maxPrice != "0") {
        url = `${url}below-aed${maxPrice}/`
      }
    }

    let actionURL = url;
    if (key === "buy") {
      actionURL = "/properties/for-sale/" + url
    } else if (key === "rent") {
      actionURL = "/properties/for-rent/" + url
    } else if (key === "commercial" && type === 1) {
      actionURL = "/properties/commercial/for-sale/" + url
    } else if (key === "commercial" && type === 2) {
      actionURL = "/properties/commercial/for-rent/" + url
    } else if (key === "off-plan") {
      actionURL = "/off-plan-properties/" + url
    }
    // navigate(actionURL);
    window.location.href = actionURL;
  }

  const clickHandle = (e) => {
    const li = e.target.closest('li');
    li.closest('ul').querySelectorAll('li').forEach(item => {
      if (item !== li) {
        item.classList.remove('active');
      }
    })
    e.target.closest('li').classList.toggle('active');
  }

  const styles = {
    control: styles => ({ ...styles, backgroundColor: '#f7fbff', border: 0, outline: 0, boxShadow: 'none', fontSize: '14px', color: '#00114A', minHeight: '3rem', paddingLeft: '1rem', marginBottom: '1rem' }),
    placeholder: (defaultStyles) => {
      return {
        ...defaultStyles,
        color: '#263140',
      }
    }
  }
  // Min price
  const priceminRangeLetting = [{ "value": "0", "label": "No Min" }, { "value": "20000", "label": "20,000 AED" }, { "value": "30000", "label": "30,000 AED" }, { "value": "40000", "label": "40,000 AED" }, { "value": "50000", "label": "50,000 AED" }, { "value": "60000", "label": "60,000 AED" }, { "value": "70000", "label": "70,000 AED" }, { "value": "80000", "label": "80,000 AED" }, { "value": "90000", "label": "90,000 AED" }, { "value": "100000", "label": "100,000 AED" }, { "value": "110000", "label": "110,000 AED" }, { "value": "120000", "label": "120,000 AED" }, { "value": "130000", "label": "130,000 AED" }, { "value": "140000", "label": "140,000 AED" }, { "value": "150000", "label": "150,000 AED" }, { "value": "160000", "label": "160,000 AED" }, { "value": "170000", "label": "170,000 AED" }, { "value": "180000", "label": "180,000 AED" }, { "value": "190000", "label": "190,000 AED" }, { "value": "200000", "label": "200,000 AED" }, { "value": "225000", "label": "225,000 AED" }, { "value": "250000", "label": "250,000 AED" }, { "value": "275000", "label": "275,000 AED" }, { "value": "300000", "label": "300,000 AED" }, { "value": "350000", "label": "350,000 AED" }, { "value": "400000", "label": "400,000 AED" }, { "value": "500000", "label": "500,000 AED" }, { "value": "750000", "label": "750,000 AED" }, { "value": "1000000", "label": "1,000,000 AED" }]
  const priceminRange = [{ "value": "0", "label": "No Min" }, { "value": "300000", "label": "300,000 AED" }, { "value": "400000", "label": "400,000 AED" }, { "value": "500000", "label": "500,000 AED" }, { "value": "600000", "label": "600,000 AED" }, { "value": "700000", "label": "700,000 AED" }, { "value": "800000", "label": "800,000 AED" }, { "value": "900000", "label": "900,000 AED" }, { "value": "1000000", "label": "1,000,000 AED" }, { "value": "1100000", "label": "1,100,000 AED" }, { "value": "1200000", "label": "1,200,000 AED" }, { "value": "1300000", "label": "1,300,000 AED" }, { "value": "1400000", "label": "1,400,000 AED" }, { "value": "1500000", "label": "1,500,000 AED" }, { "value": "1600000", "label": "1,650,000 AED" }, { "value": "1700000", "label": "1,700,000 AED" }, { "value": "1800000", "label": "1,800,000 AED" }, { "value": "1900000", "label": "1,900,000 AED" }, { "value": "2000000", "label": "2,000,000 AED" }, { "value": "2100000", "label": "2,100,000 AED" }, { "value": "2200000", "label": "2,200,000 AED" }, { "value": "2300000", "label": "2,300,000 AED" }, { "value": "2400000", "label": "2,400,000 AED" }, { "value": "2500000", "label": "2,500,000 AED" }, { "value": "2600000", "label": "2,600,000 AED" }, { "value": "2700000", "label": "2,700,000 AED" }, { "value": "2800000", "label": "2,800,000 AED" }, { "value": "2900000", "label": "2,900,000 AED" }, { "value": "3000000", "label": "3,000,000 AED" }, { "value": "3250000", "label": "3,250,000 AED" }, { "value": "3500000", "label": "3,500,000 AED" }, { "value": "3750000", "label": "3,750,000 AED" }, { "value": "4000000", "label": "4,000,000 AED" }, { "value": "4250000", "label": "4,250,000 AED" }, { "value": "4500000", "label": "4,500,000 AED" }, { "value": "5000000", "label": "5,000,000 AED" }, { "value": "6000000", "label": "6,000,000 AED" }, { "value": "7000000", "label": "7,000,000 AED" }, { "value": "8000000", "label": "8,000,000 AED" }, { "value": "9000000", "label": "9,000,000 AED" }, { "value": "10000000", "label": "10,000,000 AED" }, { "value": "25000000", "label": "25,000,000 AED" }, { "value": "50000000", "label": "50,000,000 AED" }]
  // Max Price
  const pricemaxRangeLetting = [{ "value": "0", "label": "No Max" }, { "value": "20000", "label": "20,000 AED" }, { "value": "30000", "label": "30,000 AED" }, { "value": "40000", "label": "40,000 AED" }, { "value": "50000", "label": "50,000 AED" }, { "value": "60000", "label": "60,000 AED" }, { "value": "70000", "label": "70,000 AED" }, { "value": "80000", "label": "80,000 AED" }, { "value": "90000", "label": "90,000 AED" }, { "value": "100000", "label": "100,000 AED" }, { "value": "110000", "label": "110,000 AED" }, { "value": "120000", "label": "120,000 AED" }, { "value": "130000", "label": "130,000 AED" }, { "value": "140000", "label": "140,000 AED" }, { "value": "150000", "label": "150,000 AED" }, { "value": "160000", "label": "160,000 AED" }, { "value": "170000", "label": "170,000 AED" }, { "value": "180000", "label": "180,000 AED" }, { "value": "190000", "label": "190,000 AED" }, { "value": "200000", "label": "200,000 AED" }, { "value": "225000", "label": "225,000 AED" }, { "value": "250000", "label": "250,000 AED" }, { "value": "275000", "label": "275,000 AED" }, { "value": "300000", "label": "300,000 AED" }, { "value": "350000", "label": "350,000 AED" }, { "value": "400000", "label": "400,000 AED" }, { "value": "500000", "label": "500,000 AED" }, { "value": "750000", "label": "750,000 AED" }, { "value": "1000000", "label": "1,000,000 AED" }]
  const pricemaxRange = [{ "value": "0", "label": "No Max" }, { "value": "300000", "label": "300,000 AED" }, { "value": "400000", "label": "400,000 AED" }, { "value": "500000", "label": "500,000 AED" }, { "value": "600000", "label": "600,000 AED" }, { "value": "700000", "label": "700,000 AED" }, { "value": "800000", "label": "800,000 AED" }, { "value": "900000", "label": "900,000 AED" }, { "value": "1000000", "label": "1,000,000 AED" }, { "value": "1100000", "label": "1,100,000 AED" }, { "value": "1200000", "label": "1,200,000 AED" }, { "value": "1300000", "label": "1,300,000 AED" }, { "value": "1400000", "label": "1,400,000 AED" }, { "value": "1500000", "label": "1,500,000 AED" }, { "value": "1600000", "label": "1,650,000 AED" }, { "value": "1700000", "label": "1,700,000 AED" }, { "value": "1800000", "label": "1,800,000 AED" }, { "value": "1900000", "label": "1,900,000 AED" }, { "value": "2000000", "label": "2,000,000 AED" }, { "value": "2100000", "label": "2,100,000 AED" }, { "value": "2200000", "label": "2,200,000 AED" }, { "value": "2300000", "label": "2,300,000 AED" }, { "value": "2400000", "label": "2,400,000 AED" }, { "value": "2500000", "label": "2,500,000 AED" }, { "value": "2600000", "label": "2,600,000 AED" }, { "value": "2700000", "label": "2,700,000 AED" }, { "value": "2800000", "label": "2,800,000 AED" }, { "value": "2900000", "label": "2,900,000 AED" }, { "value": "3000000", "label": "3,000,000 AED" }, { "value": "3250000", "label": "3,250,000 AED" }, { "value": "3500000", "label": "3,500,000 AED" }, { "value": "3750000", "label": "3,750,000 AED" }, { "value": "4000000", "label": "4,000,000 AED" }, { "value": "4250000", "label": "4,250,000 AED" }, { "value": "4500000", "label": "4,500,000 AED" }, { "value": "5000000", "label": "5,000,000 AED" }, { "value": "6000000", "label": "6,000,000 AED" }, { "value": "7000000", "label": "7,000,000 AED" }, { "value": "8000000", "label": "8,000,000 AED" }, { "value": "9000000", "label": "9,000,000 AED" }, { "value": "10000000", "label": "10,000,000 AED" }, { "value": "25000000", "label": "25,000,000 AED" }, { "value": "50000000", "label": "50,000,000 AED" }]


  var options = [
    { value: 1, label: "Buy" },
    { value: 2, label: 'Rent' }
  ]
  var defaultValue = { value: 1, label: "Buy" };
  if (props.type === "Rent") {
    if (type === 1 && !firstRender) {
      setType(2)
      setFirstRender(true)
    }
    defaultValue = { value: 2, label: "Rent" };
  }


  var minRange = [];
  if (type == 1) {
    minRange = priceminRange;
  } else {
    minRange = priceminRangeLetting;
  }

  if (maxPrice !== undefined && maxPrice != "0") {
    minRange = minRange.filter((x) => x.value == "0" || parseInt(x.value) < parseInt(maxPrice))
  }

  var maxRange = [];
  if (type == 1) {
    maxRange = pricemaxRange;
  } else {
    maxRange = pricemaxRangeLetting;
  }

  if (minPrice !== undefined && minPrice != "0") {
    maxRange = maxRange.filter((x) => x.value == "0" || parseInt(x.value) > parseInt(minPrice))
  }
  return (
    <React.Fragment>
      <div className="banner-search advance-banner-search d-block">
        <Tabs
          id="controlled-tab-example"
          activeKey={key}
          onSelect={(k) => setKey(k)}>

          <Tab eventKey="buy" title="Buy">
            <Form.Group className="d-flex align-items-center justify-content-left select-text-residential">


              <div className='search-input non-commercial d-flex align-items-center'>
                <Link to="#" className="search-location"><i className="search-icon"></i></Link>
                <SearchInputBox type="non-commercial" areas={areas} />
              </div>

              <input type="hidden" name="type" classNamePrefix={"select-opt"} defaultValue={0} />



              <div className="banner-select-box property-type-select d-none d-lg-block">
                <Select
                  name="building"
                  options={[
                    { value: "", label: "All" },
                    { value: "apartment", label: "Apartments" },
                    { value: "villa", label: "Villas" },
                    { value: "townhouse", label: "Townhouses" },
                    { value: "penthouse", label: "Penthouses" },
                    { value: "land", label: "Lands" },
                    { value: "plot", label: "Plots" },
                    { value: "full-floor", label: "Full floors" },
                    { value: "duplex", label: "Duplexes" },
                    { value: "whole-building", label: "Whole Building" },
                    { value: "hotel-apartment", label: "Hotel/Hotel Apartments" },
                    // { value: "shop", label: "Shop" }
                    // { value: "property", label: "Others" },
                  ]}
                  placeholder="Property Type"
                  classNamePrefix={"select-opt"}
                  onChange={(e) => { setPropertyType(e.value) }}
                  styles={styles}
                  isSearchable={false}
                // menuIsOpen={true}
                />
              </div>


              <div className="banner-select-box bed-selectbox d-none d-lg-block">
                <Select
                  name="beds"
                  options={[
                    { value: "", label: "Any" },
                    { value: '1', label: '1 +' },
                    { value: '2', label: '2 +' },
                    { value: '3', label: '3 +' },
                    { value: '4', label: '4 +' },
                    { value: '5', label: '5 +' },
                    { value: '6', label: '6 +' },
                    { value: '7', label: '7 +' },
                    { value: '8', label: '8 +' },
                    { value: '9', label: '9 +' }
                  ]}
                  // menuIsOpen={true}
                  onChange={(e) => { setBeds(e.value) }}
                  placeholder="Beds"
                  classNamePrefix={"select-opt"}
                  isSearchable={false}
                />
              </div>


              <div className="banner-select-box filter-select-field d-none d-lg-block">
                <ul className="filter-list">
                  <li className="price-filter-dropdown">
                    <button type="button" onClick={clickHandle} className="d-flex align-items-center">Price <i className="icon-dropdown-arrow-price"></i></button>
                    <div className="filter-dropdown">
                      <div className="select">
                        <Select
                          name="minprice"
                          options={minRange}
                          placeholder="Min Price"
                          styles={styles}
                          onChange={(e) => { setMinPrice(e.value) }}
                          classNamePrefix={"select-opt"}
                          isSearchable={false}
                        // menuIsOpen={true}
                        />
                      </div>

                      <div className="select">
                        <Select
                          name="maxprice"
                          options={maxRange}
                          placeholder="Max Price"
                          onChange={(e) => { setMaxPrice(e.value) }}
                          styles={styles}
                          classNamePrefix={"select-opt"}
                          isSearchable={false}
                        // menuIsOpen={true}
                        />
                      </div>
                    </div>
                  </li>
                </ul>
              </div>

              <div className="search-btn">
                <a href="javascript:void(0)" onClick={() => { advanceSearch(); }} className="advance_search_btn" variant="primary">
                  <i className="icon-search"></i>
                </a>
              </div>
            </Form.Group>
          </Tab>

          <Tab eventKey="rent" title="Rent">
            <Form.Group className="d-flex align-items-center justify-content-left select-text-residential">
              {/* <div className="banner-select-box buyrent-selectbox">           
                   </div> */}

              <div className='search-input non-commercial d-flex align-items-center'>
                <Link to="#" className="search-location"><i className="search-icon"></i></Link>
                <SearchInputBox type="non-commercial" areas={areas} />

                <input type="hidden" name="type" classNamePrefix={"select-opt"}
                  defaultValue={1} />
              </div>
              <div className="banner-select-box property-type-select d-none d-lg-block">
                <Select
                  name="building"
                  options={[
                    { value: "", label: "All" },
                    { value: "apartment", label: "Apartments" },
                    { value: "villa", label: "Villas" },
                    { value: "townhouse", label: "Townhouses" },
                    { value: "penthouse", label: "Penthouses" },
                    { value: "land", label: "Lands" },
                    { value: "plot", label: "Plots" },
                    { value: "full-floor", label: "Full floors" },
                    { value: "duplex", label: "Duplexes" },
                    { value: "whole-building", label: "Whole Building" },
                    { value: "hotel-apartment", label: "Hotel/Hotel Apartments" },
                    // { value: "shop", label: "Shop" }
                    // { value: "property", label: "Others" },
                  ]}
                  placeholder="Property Type"
                  classNamePrefix={"select-opt"}
                  onChange={(e) => { setPropertyType(e.value) }}
                  styles={styles}
                  isSearchable={false}
                // menuIsOpen={true}
                />
              </div>
              <div className="banner-select-box bed-selectbox d-none d-lg-block">
                <Select
                  name="beds"
                  options={[
                    { value: "", label: "Any" },
                    { value: '1', label: '1 +' },
                    { value: '2', label: '2 +' },
                    { value: '3', label: '3 +' },
                    { value: '4', label: '4 +' },
                    { value: '5', label: '5 +' },
                    { value: '6', label: '6 +' },
                    { value: '7', label: '7 +' },
                    { value: '8', label: '8 +' },
                    { value: '9', label: '9 +' }
                  ]}
                  // menuIsOpen={true}
                  onChange={(e) => { setBeds(e.value) }}
                  placeholder="Beds"
                  classNamePrefix={"select-opt"}
                  isSearchable={false}
                />
              </div>
              <div className="banner-select-box filter-select-field d-none d-lg-block">
                <ul className="filter-list">
                  <li className="price-filter-dropdown">
                    <button type="button" onClick={clickHandle} className="d-flex align-items-center">Price <i className="icon-dropdown-arrow-price"></i></button>
                    <div className="filter-dropdown">
                      <div className="select">
                        <Select
                          name="minprice"
                          options={minRange}
                          placeholder="Min Price"
                          styles={styles}
                          onChange={(e) => { setMinPrice(e.value) }}
                          classNamePrefix={"select-opt"}
                          isSearchable={false}
                        // menuIsOpen={true}
                        />
                      </div>

                      <div className="select">
                        <Select
                          name="maxprice"
                          options={maxRange}
                          placeholder="Max Price"
                          onChange={(e) => { setMaxPrice(e.value) }}
                          styles={styles}
                          classNamePrefix={"select-opt"}
                          isSearchable={false}
                        // menuIsOpen={true}
                        />
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="search-btn">
                <a href="javascript:void(0)" onClick={() => { advanceSearch(); }} className="advance_search_btn" variant="primary">
                  <i className="icon-search"></i>
                </a>
              </div>
            </Form.Group>
          </Tab>

          <Tab eventKey="off-plan" title="Off Plan">
            <Form.Group className="d-flex align-items-center justify-content-left select-text-offplan">
              <div className='search-input offplan d-flex align-items-center search-box-offplan'>
                <Link to="#" className="search-location"><i className="search-icon"></i></Link>
                <SearchInputBox type="off-plan" areas={areas} />
              </div>

              <div className="banner-select-box property-type-select select-box-offplan d-none d-lg-block">
                <Select
                  name="building"
                  options={[
                    { value: "", label: "All" },
                    { value: "apartments", label: "Apartments" },
                    { value: "villas", label: "Villas" },
                    { value: "townhouse", label: "Townhouses" },
                    { value: "penthouse", label: "Penthouses" },
                    { value: "duplex", label: "Duplexes" },
                    { value: "mansions", label: "Mansions" },
                    { value: "sky-villas", label: "Sky Villas" },
                    { value: "luxury-apartment", label: "Luxury Apartments" },
                    { value: "luxury-villa", label: "Luxury villas" },
                    { value: "hotel-apartment", label: "Hotel/Hotel Apartments" },
                    { value: "residential", label: "residential Apartments / Tower" },
                    { value: "residences", label: "Residences" },
                  ]}
                  placeholder="Property Type"
                  classNamePrefix={"select-opt"}
                  onChange={(e) => { setPropertyType(e.value) }}
                  styles={styles}
                  isSearchable={false}
                // menuIsOpen={true}
                />
              </div>
              <div className="banner-select-box bed-selectbox d-none d-lg-block">
                <Select
                  name="beds"
                  options={[
                    { value: "", label: "Any" },
                    { value: '1', label: '1 +' },
                    { value: '2', label: '2 +' },
                    { value: '3', label: '3 +' },
                    { value: '4', label: '4 +' },
                    { value: '5', label: '5 +' },
                    { value: '6', label: '6 +' },
                    { value: '7', label: '7 +' },
                    { value: '8', label: '8 +' },
                    { value: '9', label: '9 +' }
                  ]}
                  // menuIsOpen={true}
                  onChange={(e) => { setBeds(e.value) }}
                  placeholder="Beds"
                  classNamePrefix={"select-opt"}
                  isSearchable={false}
                />
              </div>
              <div className="banner-select-box filter-select-field d-none d-lg-block">
                <ul className="filter-list">
                  <li className="price-filter-dropdown">
                    <button type="button" onClick={clickHandle} className="d-flex align-items-center">Price <i className="icon-dropdown-arrow-price"></i></button>
                    <div className="filter-dropdown">
                      <div className="select">
                        <Select
                          name="minprice"
                          options={minRange}
                          placeholder="Min Price"
                          styles={styles}
                          onChange={(e) => { setMinPrice(e.value) }}
                          classNamePrefix={"select-opt"}
                          isSearchable={false}
                        />
                      </div>
                      <div className="select">
                        <Select
                          name="maxprice"
                          options={maxRange}
                          placeholder="Max Price"
                          onChange={(e) => { setMaxPrice(e.value) }}
                          styles={styles}
                          classNamePrefix={"select-opt"}
                          isSearchable={false}
                        // menuIsOpen={true}
                        />
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div className='search-btn'>
                <a href="javascript:void(0)" onClick={() => { advanceSearch(); }} className="advance_search_btn" variant="primary">
                  <i className="icon-search"></i>
                </a>
              </div>
            </Form.Group>
          </Tab>


          <Tab eventKey="commercial" title="Commercial">
            <Form.Group className="d-flex align-items-center justify-content-left select-text-commercial">

              <div className='search-input commercial d-flex align-items-center search-box-commercial'>
                <Link to="#" className="search-location"><i className="search-icon"></i></Link>
                <SearchInputBox type="commercial" areas={areas} />
              </div>
              <div className="banner-select-box buyrent-selectbox d-none d-lg-block">
                <Select
                  name="type"
                  options={options}
                  onChange={(e) => {
                    setType(e.value)
                  }}
                  classNamePrefix={"select-opt"}
                  defaultValue={defaultValue}
                  isSearchable={false}
                  styles={styles}
                // menuIsOpen={true}
                />
              </div>
              <div className="banner-select-box property-type-select select-box-commercial d-none d-lg-block">
                <Select
                  name="building"
                  options={[
                    { value: "", label: "All" },
                    { value: "office", label: "Offices" },
                    { value: "warehouse", label: "Warehouses" },
                    { value: "retail", label: "Retails" },
                    { value: "shop", label: "Shops" },
                    { value: "whole-building", label: "Whole Buildings" },
                    { value: "business-center", label: "Business Centers" },
                    { value: "labor-camp", label: "Labor Camps" },
                    { value: "showroom", label: "Showrooms" },
                    { value: "staff-accomodation", label: "Staff accomodations" },
                    { value: "restaurant", label: "Restaurants" },
                    { value: "farm", label: "Farms" },

                    // { value: "property", label: "Others" },
                  ]}
                  placeholder="Property Type"
                  classNamePrefix={"select-opt"}
                  onChange={(e) => { setPropertyType(e.value) }}
                  styles={styles}
                  isSearchable={false}
                // menuIsOpen={true}
                />
              </div>
              <div className="banner-select-box filter-select-field d-none d-lg-block">
                <ul className="filter-list">
                  <li className="price-filter-dropdown">
                    <button type="button" onClick={clickHandle} className="d-flex align-items-center">Price <i className="icon-dropdown-arrow-price"></i></button>
                    <div className="filter-dropdown">
                      <div className="select">
                        <Select
                          name="minprice"
                          options={minRange}
                          placeholder="Min Price"
                          styles={styles}
                          onChange={(e) => { setMinPrice(e.value) }}
                          classNamePrefix={"select-opt"}
                          isSearchable={false}
                        />
                      </div>
                      <div className="select">
                        <Select
                          name="maxprice"
                          options={maxRange}
                          placeholder="Max Price"
                          onChange={(e) => { setMaxPrice(e.value) }}
                          styles={styles}
                          classNamePrefix={"select-opt"}
                          isSearchable={false}
                        // menuIsOpen={true}
                        />
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div className='search-btn'>
                <a href="javascript:void(0)" onClick={() => { advanceSearch(); }} className="advance_search_btn" variant="primary">
                  <i className="icon-search"></i>
                </a>
              </div>
            </Form.Group>
          </Tab>

        </Tabs>
      </div>
    </React.Fragment >
  )
}

export default HeroSearch